import React from "react";
import { useNavigate } from "react-router-dom";

function MenuViewBanner() {
  const navigate = useNavigate();

  const handleViewMenu = () => {
    navigate("/menu");
  };

  return (
    <section
      className="w-full py-8 sm:py-12 text-center"
      style={{ backgroundColor: "#5786ff" }}
    >
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-relaxed mb-8 max-w-2xl mx-auto"
          style={{
            fontFamily: "'Signika Negative', sans-serif",
          }}
        >
          A Plus Flavor restaurant ensures your entire party can
          find meals they will love from our menu.
        </h2>

        <button
          onClick={handleViewMenu}
          className="text-white px-10 py-4 text-lg font-semibold uppercase tracking-wider rounded transition-all duration-300 hover:shadow-xl hover:-translate-y-1 font-geom"
          style={{ backgroundColor: "#f2340a" }}
          onMouseEnter={(e) =>
            (e.target.style.backgroundColor = "#d91f00")
          }
          onMouseLeave={(e) =>
            (e.target.style.backgroundColor = "#f2340a")
          }
        >
          View Menu
        </button>
      </div>
    </section>
  );
}

export default MenuViewBanner;
